const SS_KEY = "ts_auth_flow";
const REF_KEY = "ts_referral";
const UTM_KEY = "ts_utm";
const REDIRECT_KEY = "ts_auth_redirect";

export type FlowState = {
  mobile?: string;
  isNewUser?: boolean;
  resetPhase?: "request" | "verify" | "set" | "done";
  otpRequestedAt?: number;
};

const isBrowser = () => typeof window !== "undefined";

function read<T>(key: string, fallback: T): T {
  if (!isBrowser()) return fallback;
  try {
    const raw = sessionStorage.getItem(key);
    return raw ? (JSON.parse(raw) as T) : fallback;
  } catch {
    return fallback;
  }
}

function write(key: string, value: unknown) {
  if (!isBrowser()) return;
  try {
    sessionStorage.setItem(key, JSON.stringify(value));
  } catch {}
}

function remove(key: string) {
  if (!isBrowser()) return;
  try {
    sessionStorage.removeItem(key);
  } catch {}
}

export function getFlow(): FlowState {
  return read<FlowState>(SS_KEY, {});
}

export function setFlow(patch: Partial<FlowState>) {
  write(SS_KEY, { ...getFlow(), ...patch });
}

export function clearFlow() {
  remove(SS_KEY);
}

export function captureMarketingFromUrl(search: string) {
  if (!isBrowser()) return;
  const params = new URLSearchParams(search);
  const ref = params.get("ref");
  if (ref) {
    const cleaned = ref
      .replace(/[^A-Za-z0-9]/g, "")
      .slice(0, 5)
      .toUpperCase();
    if (cleaned) write(REF_KEY, cleaned);
  }
  const utm: Record<string, string> = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"].forEach((k) => {
    const v = params.get(k);
    if (v) utm[k] = v.slice(0, 64);
  });
  if (Object.keys(utm).length) write(UTM_KEY, utm);
}

export function getReferral(): string | null {
  return read<string | null>(REF_KEY, null);
}

export function clearMarketing() {
  remove(REF_KEY);
  remove(UTM_KEY);
}

export function setAuthRedirect(target: string) {
  write(REDIRECT_KEY, target);
}

export function getAuthRedirect(): string | null {
  return read<string | null>(REDIRECT_KEY, null);
}

export function clearAuthRedirect() {
  remove(REDIRECT_KEY);
}
